import { Breadcrumb, Popover } from 'antd';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import {
  ACTIVITY_ROUTE,
  DASHBOARD_ROUTE,
  DETAILS_ROUTE
} from '../../constants';
import { getProjectRequest } from '../../redux/slicers/projects';
import { Images } from '../../theme';

import './styles.scss';

function ProjectAcivityBreadCrumbs() {
  const params = useParams();
  const dispatch = useDispatch();

  const state = useSelector((state) => state);

  const { projectList } = state?.projects;
  const project = projectList?.find((p) => p._id === params.id);

  useEffect(() => {
    if (_.isEmpty(project)) {
      dispatch(getProjectRequest({}, () => {}));
    }
  }, []);

  const content = () => {
    return (
      <div className="breadCrumbWrapper">
        <Link to={DASHBOARD_ROUTE} className="customBreadcrumbMobView">
          Dashboard
        </Link>

        <Link
          className="customBreadcrumbMobView"
          to={DETAILS_ROUTE.replace(':id', params.id)}
        >
          {project?.projectname}
        </Link>

        <Link
          className="customBreadcrumbMobView"
          to={ACTIVITY_ROUTE.replace(':id', params.id)}
        >
          Activity Logs
        </Link>
      </div>
    );
  };

  return (
    <>
      <div className="breadCrumbWebView">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link className="customBreadcrumb" to={DASHBOARD_ROUTE}>
              Dashboard
            </Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={DETAILS_ROUTE.replace(':id', params.id)}
            >
              {project?.projectname}
            </Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={ACTIVITY_ROUTE.replace(':id', params.id)}
            >
              Activity Logs
            </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="breadCrumbMobView">
        <Popover content={content()} trigger="click">
          <img src={Images.folder} height={30} width={30} />
        </Popover>

        <Breadcrumb>
          <Breadcrumb.Item>
            <Link
              className="customBreadcrumb"
              to={ACTIVITY_ROUTE.replace(':id', params.id)}
            >
              Activity Logs
            </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    </>
  );
}

export default ProjectAcivityBreadCrumbs;
